import React, { useMemo } from 'react';

import { barChart } from 'ionicons/icons';

import clsx from 'clsx';

import EmptyContent from 'components/EmptyContent';
import ErrorContent from 'components/ErrorContent';
import { useScreenState } from 'components/Screen';
import {
  COLUMNS,
  DIMENSION,
  FILTERS,
  TABLE_SETTINGS,
} from 'scenes/PerformancePage/constants';
import { useDataTable } from 'scenes/PerformancePage/data';

import DataTableOrigin from './components/DataTable';
import DataTableSkeleton from './components/DataTableSkeleton';
import './index.css';

const DataTable = () => {
  const screenState = useScreenState();
  const { data, isRefetching, isLoading, isError, error, isSuccess }: any =
    useDataTable({
      [FILTERS]: screenState[FILTERS],
      [TABLE_SETTINGS]: screenState[TABLE_SETTINGS],
      [COLUMNS]: screenState[COLUMNS],
      [DIMENSION]: screenState[DIMENSION],
    });

  const isEmpty = useMemo(() => {
    return (data && data?.paging?.count === 0) ?? true;
  }, [data]);

  const renderComponent = useMemo(() => {
    switch (true) {
      case isError: //Loaded with error response
        return (
          <ErrorContent
            icon={barChart}
            isRefetching={isRefetching}
            error={error}
            withRadius={false}
          />
        );
      case isLoading:
        return <DataTableSkeleton />; //No loaded
      case isEmpty:
        return (
          <EmptyContent
            icon={barChart}
            isRefetching={isRefetching}
            withRadius={false}
          />
        ); //Loaded with empty response
      case isSuccess: //Loaded with normal response
        return <DataTableOrigin isRefetching={isRefetching} data={data} />;

      default:
        return null;
    }
  }, [isLoading, isRefetching, isEmpty, isSuccess, isError, data, error]);

  return (
    <div className={'datatable'}>
      {renderComponent}
      <div
        className={clsx({
          'datatable-overlay': true,
          'datatable-refetching': isRefetching,
        })}
      />
    </div>
  );
};
export default DataTable;
